<template>
  <div class="app-container">
    <el-card class="card">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-date-picker
            v-model="condition.bookingTime"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="航司" v-model="condition.carrier" style="width:100%" clearable></el-input>
        </el-col>
        <el-col :span="6">
          <el-autocomplete
            class="inline-input"
            v-model="condition.fromCity"
            :fetch-suggestions="querySearchCity"
            placeholder="出发城市"
            :trigger-on-focus="false"
            @select="handleSelectFromCity"
            style="width:100%"
            clearable
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.name }}</div>
            </template>
          </el-autocomplete>
        </el-col>
        <el-col :span="6">
          <el-autocomplete
            class="inline-input"
            v-model="condition.toCity"
            :fetch-suggestions="querySearchCity"
            placeholder="到达城市"
            :trigger-on-focus="false"
            @select="handleSelectToCity"
            style="width:100%"
            clearable
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.name }}</div>
            </template>
          </el-autocomplete>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="2">
          <span class="el_col_span"> 航司:</span>
        </el-col>
        <el-col :span="22">
          <el-radio-group v-model="condition.carrierType" size="small">
            <el-radio :label="-1">全部</el-radio>
            <el-radio :label="0">全服</el-radio>
            <el-radio :label="1">廉航</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="2">
          <span class="el_col_span"> 售前时间类型:</span>
        </el-col>
        <el-col :span="22">
          <el-radio-group v-model="condition.preSaleTimeType" size="small">
            <el-radio :label="1">生单</el-radio>
            <el-radio :label="2">出票</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="2">
          <span class="el_col_span"> 售后时间类型:</span>
        </el-col>
        <el-col :span="22">
          <el-radio-group v-model="condition.afterAleTimeType" size="small">
            <el-radio :label="1">操作完成时间</el-radio>
            <el-radio :label="2">申请时间</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="2">
          <span class="el_col_span"> 订单类型:</span>
        </el-col>
        <el-col :span="22">
          <el-radio-group v-model="condition.orderType" size="small">
            <el-radio :label="-1">全部</el-radio>
            <el-radio :label="0">运价直连</el-radio>
            <el-radio :label="1">手工政策</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="2">
          <span class="el_col_span"> 供应商维度:</span>
        </el-col>
        <el-col :span="22">
          <el-radio-group v-model="condition.supplierType" size="small" @change="changeSupplierType()">
            <el-radio :label="-1">全部</el-radio>
            <el-radio :label="1">原始供应商</el-radio>
            <el-radio :label="2">出票供应商</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="margin-top:15px;" v-if="queryPccFlag">
        <el-col :span="2"> &nbsp;</el-col>
        <el-col :span="22">
          <el-checkbox-group v-model="condition.pccs">
            <el-checkbox v-for="(supplier, index) in suppliers" :label="supplier.pcc" :key="index">{{
              supplier.name
            }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="2">
          <span class="el_col_span"> 热度:</span>
        </el-col>
        <el-col :span="22">
          <el-radio-group v-model="condition.heat" size="small">
            <el-radio :label="1">TOP10</el-radio>
            <el-radio :label="2">TOP20</el-radio>
            <el-radio :label="3">TOP50</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="2">
          <span class="el_col_span"> 渠道:</span>
        </el-col>
        <el-col :span="22">
          <el-radio-group v-model="condition.channelType" size="small" @change="changeChannelType()">
            <el-radio :label="-1">全部</el-radio>
            <el-radio :label="0">API</el-radio>
            <el-radio :label="1">B2B</el-radio>
            <el-radio :label="10">线下</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row :gutter="24" style="margin-top:15px;" v-if="queryCidFlag">
        <el-col :span="2"> &nbsp;</el-col>
        <el-col :span="22">
          <el-checkbox-group v-model="condition.cids">
            <el-checkbox v-for="(openCid, index) in openCids" :label="openCid.cid" :key="index">{{
              openCid.name
            }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="margin-top:15px;">
        <el-col :span="24">
          <el-button type="primary" @click="Search()" icon="el-icon-search">查询</el-button>
          <el-button @click="toResetCondition()" icon="el-icon-refresh">重置</el-button>
          <el-button v-if="hasExportPrivilege" type="warning" @click="exportData()" icon="el-icon-download"
            >导出</el-button
          >
        </el-col>
      </el-row>
    </el-card>

    <!--渠道销售数据-->
    <el-card class="card_2">
      <el-row>
        <el-col :span="22">
          <h2 style="margin-top:1px;" class="title">
            销售数据
          </h2>
        </el-col>
      </el-row>

      <el-table
        :data="channelSaleDataVos"
        border
        stripe
        show-header
        show-summary
        :summary-method="getSummaries"
        highlight-current-row
        v-loading="fullscreenLoading"
        element-loading-text="努力加载中..."
        :header-cell-style="{ background: '#F5F7FA', color: '#000000' }"
        class="table_"
      >
        <el-table-column prop="cid" label="渠道" align="center" sortable> </el-table-column>
        <el-table-column prop="channelName" label="渠道中文名" align="center" sortable> </el-table-column>
        <el-table-column prop="passengerNum" label="人数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="ticketNum" label="票数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="orderNum" label="订单数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentNum" label="航段数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentFee" label="航段费" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="prepaidAmount" label="预亏金额(预亏率)" align="center" min-width="80px;" sortable>
        </el-table-column>
        <el-table-column prop="salesAmount" label="销售额" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            {{ parseFloat(scope.row.auxiliarySalesAmount + scope.row.salesAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="averageFare" label="平均票价" align="center" min-width="60px;" sortable>
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithOutSegment"
          label="售前利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithSegment"
          label="售前利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="preSalesProfitMargin" label="售前利润率" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSalesProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundProfit" label="退票利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="changeProfit" label="改期利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="totalProfitAfterSale" label="售后利润总计" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="auxiliaryProfit" label="辅营利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="compensateProfit" label="赔付差异单利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column
          prop="totalProfitWithOutSegment"
          label="总利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="totalProfitWithSegment"
          label="总利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="grossProfitMargin" label="毛利率" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.grossProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="preSaleProfitRatio" label="售前利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSaleProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="afterSalesProfitRatio" label="售后利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.afterSalesProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="auxiliaryProfitRatio" label="辅营利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.auxiliaryProfitRatio }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!--供应商销售数据-->
    <el-card class="card_2">
      <el-row>
        <el-col :span="22">
          <h2 style="margin-top:1px;" class="title">
            供应商数据
          </h2>
        </el-col>
      </el-row>

      <el-table
        :data="supplierSaleDataVos"
        border
        show-header
        show-summary
        :summary-method="getSummaries"
        v-loading="fullscreenLoading"
        element-loading-text="努力加载中..."
        :header-cell-style="{ background: '#F5F7FA', color: '#000000' }"
        class="table_"
      >
        <el-table-column prop="pcc" label="供应商" align="center" sortable></el-table-column>
        <el-table-column prop="supplierName" label="供应商中文名" align="center" sortable> </el-table-column>
        <el-table-column prop="passengerNum" label="人数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="ticketNum" label="票数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="orderNum" label="订单数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentNum" label="航段数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentFee" label="航段费" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="prepaidAmount" label="预亏金额(预亏率)" align="center" min-width="80px;" sortable>
        </el-table-column>
        <el-table-column prop="salesAmount" label="销售额" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            {{ parseFloat(scope.row.auxiliarySalesAmount + scope.row.salesAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="averageFare" label="平均票价" align="center" min-width="60px;" sortable>
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithOutSegment"
          label="售前利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithSegment"
          label="售前利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="preSalesProfitMargin" label="售前利润率" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSalesProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundProfit" label="退票利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="changeProfit" label="改期利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="totalProfitAfterSale" label="售后利润总计" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="auxiliaryProfit" label="辅营利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="compensateProfit" label="赔付差异单利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column
          prop="totalProfitWithOutSegment"
          label="总利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="totalProfitWithSegment"
          label="总利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="grossProfitMargin" label="毛利率" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.grossProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="preSaleProfitRatio" label="售前利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSaleProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="afterSalesProfitRatio" label="售后利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.afterSalesProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="auxiliaryProfitRatio" label="辅营利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.auxiliaryProfitRatio }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!--航司数据-->
    <el-card class="card_2">
      <el-row>
        <el-col :span="22">
          <h2 style="margin-top:1px;" class="title">
            航司数据
          </h2>
        </el-col>
      </el-row>

      <el-table
        :data="carrierSaleDataVos"
        border
        show-header
        show-summary
        :summary-method="getSummaries2"
        v-loading="fullscreenLoading"
        element-loading-text="努力加载中..."
        :header-cell-style="{ background: '#F5F7FA', color: '#000000' }"
        class="table_"
      >
        <el-table-column prop="carrier" label="航司" align="center" sortable> </el-table-column>
        <el-table-column prop="passengerNum" label="人数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="ticketNum" label="票数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="orderNum" label="订单数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentNum" label="航段数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentFee" label="航段费" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="prepaidAmount" label="预亏金额(预亏率)" align="center" min-width="80px;" sortable>
        </el-table-column>
        <el-table-column prop="salesAmount" label="销售额" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            {{ parseFloat(scope.row.auxiliarySalesAmount + scope.row.salesAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="averageFare" label="平均票价" align="center" min-width="60px;" sortable>
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithOutSegment"
          label="售前利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithSegment"
          label="售前利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="preSalesProfitMargin" label="售前利润率" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSalesProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundProfit" label="退票利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="changeProfit" label="改期利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="totalProfitAfterSale" label="售后利润总计" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="auxiliaryProfit" label="辅营利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="compensateProfit" label="赔付差异单利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column
          prop="totalProfitWithOutSegment"
          label="总利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="totalProfitWithSegment"
          label="总利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="grossProfitMargin" label="毛利率" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.grossProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="preSaleProfitRatio" label="售前利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSaleProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="afterSalesProfitRatio" label="售后利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.afterSalesProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="auxiliaryProfitRatio" label="辅营利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.auxiliaryProfitRatio }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!--航线数据-->
    <el-card class="card_2">
      <el-row>
        <el-col :span="22">
          <h2 style="margin-top:1px;" class="title">
            航线数据
          </h2>
        </el-col>
      </el-row>

      <el-table
        :data="airlineSaleDataVos"
        border
        show-header
        show-summary
        :summary-method="getSummaries2"
        v-loading="fullscreenLoading"
        element-loading-text="努力加载中..."
        :header-cell-style="{ background: '#F5F7FA', color: '#000000' }"
        class="table_"
      >
        <el-table-column prop="airline" label="航线" align="center" sortable> </el-table-column>
        <el-table-column prop="passengerNum" label="人数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="ticketNum" label="票数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="orderNum" label="订单数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentNum" label="航段数" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="segmentFee" label="航段费" align="center" min-width="50px;" sortable> </el-table-column>
        <el-table-column prop="prepaidAmount" label="预亏金额(预亏率)" align="center" min-width="80px;" sortable>
        </el-table-column>
        <el-table-column prop="salesAmount" label="销售额" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            {{ parseFloat(scope.row.auxiliarySalesAmount + scope.row.salesAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="averageFare" label="平均票价" align="center" min-width="60px;" sortable>
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithOutSegment"
          label="售前利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="preSaleProfitWithSegment"
          label="售前利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="preSalesProfitMargin" label="售前利润率" align="center" min-width="80px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSalesProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundProfit" label="退票利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="changeProfit" label="改期利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="totalProfitAfterSale" label="售后利润总计" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="auxiliaryProfit" label="辅营利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column prop="compensateProfit" label="赔付差异单利润" align="center" min-width="50px;" sortable>
        </el-table-column>
        <el-table-column
          prop="totalProfitWithOutSegment"
          label="总利润(不含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="totalProfitWithSegment"
          label="总利润(含航段费)"
          align="center"
          min-width="80px;"
          sortable
        >
        </el-table-column>
        <el-table-column prop="grossProfitMargin" label="毛利率" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.grossProfitMargin }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="preSaleProfitRatio" label="售前利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.preSaleProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="afterSalesProfitRatio" label="售后利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.afterSalesProfitRatio }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="auxiliaryProfitRatio" label="辅营利润占比" align="center" min-width="50px;" sortable>
          <template slot-scope="scope">
            <span style="display:block">{{ scope.row.auxiliaryProfitRatio }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!--计算公式-->
    <el-card class="card_2">
      <el-row>
        <el-col :span="22">
          <h2 style="margin-top:1px;" class="title">
            计算公式
          </h2>
        </el-col>
      </el-row>
      <el-row style="margin-top:10px;">
        <el-col :span="1" style="font-size:15px;">&nbsp;</el-col>
        <el-col :span="23" style="font-size:15px;">
          <span style="display:block; magin-top:20px;">平均票价：销售额/票数</span>
          <span style="display:block; magin-top:20px;">(不含航段费)售前利润：销售额-渠道佣金-出票金额</span>
          <span style="display:block; magin-top:6px;">(含航段费)售前利润：销售额-渠道佣金-出票金额＋航段费</span>
          <span style="display:block; magin-top:6px;">售前利润率：售前利润(含航段费)/出票金额</span>
          <span style="display:block; magin-top:6px;">售后利润总计：退票利润+妀期利润</span>
          <span style="display:block; magin-top:6px;"
            >(不含航段费)总利润：(不含航段费)售前利润+退票利润＋改期利润＋辅营利润</span
          >
          <span style="display:block; magin-top:6px;"
            >(含航段费)总利润：(含航段费)售前利润＋退票利润＋改期利润＋辅营利润</span
          >
          <span style="display:block; magin-top:6px;">毛利率：(含航段费)总利润/销售额 </span>
          <span style="display:block; magin-top:6px;">售前利润占比：(含航段费)售前利润/(含航段费)总利润</span>
          <span style="display:block; magin-top:6px;">售后利润占比: 售后利润/(含航段费)总利润</span>
          <span style="display:block; magin-top:6px;">辅营利润占比: 辅营利润/(含航段费)总利润</span>
        </el-col>
      </el-row>
    </el-card>

    <data-export ref="dataExport" :exportType="exportType" :condition="condition" />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import * as saleApi from '@/api/sale'
import * as commonApi from '@/api/common'
import { tokenVerify } from '@/util/common'
import userManager from '@/sso/user-manager'
import permissionCodes from '@/sso/permission-code'
import DataExport from '@/components/DataExport'

export default {
  name: 'SaleDataList',
  components: {
    DataExport,
  },
  data() {
    return {
      queryPccFlag: false,
      queryCidFlag: false,
      suppliers: null,
      openCids: null,
      exportType: 'Sale',
      exportVisible: false,
      hasExportPrivilege: this.getExportPrivilege(),
      // 查询参数
      condition: {
        pccs: [],
        // 时间
        timeStart: null,
        timeEnd: null,
        //航司
        carrier: null,
        //出发到达
        fromCity: null,
        toCity: null,
        // 航司类型
        carrierType: -1,
        // 售前时间类型
        preSaleTimeType: 1,
        // 售后时间类型
        afterAleTimeType: 1,
        // 订单类型
        orderType: -1,
        // 订单维度
        supplierType: -1,
        // 热度
        heat: 1,
        // 渠道类型
        channelType: -1,
        // 渠道
        cidType: -1,
        cids: [],
        bookingTime: [
          dayjs()
            .hour(0)
            .minute(0)
            .second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
          dayjs()
            .hour(23)
            .minute(59)
            .second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
        ],
      },

      // 查询加载样式
      fullscreenLoading: false,

      // 销售数据
      channelSaleDataVos: [],
      supplierSaleDataVos: [],
      carrierSaleDataVos: [],
      airlineSaleDataVos: [],
    }
  },
  created() {
    this.initSupplierData()
    this.initOpenCid()
  },
  methods: {
    // 加载供应商信息
    async initSupplierData() {
      const response = await commonApi.queryAllSupplier()
      this.suppliers = response.data.data
    },
    async initOpenCid() {
      //加载cid列表
      const openCidResponse = await commonApi.queryAllOpenCid()
      this.openCids = openCidResponse.data.data
    },
    exportData() {
      this.$refs.dataExport.exportVisible('/export/sale', '销售数据导出')
    },
    getExportPrivilege() {
      return userManager.checkPermission([permissionCodes.SaleManage])
    },
    // 查询数据
    async Search() {
      if (this.condition.bookingTime == null || this.condition.bookingTime.length === 0) {
        this.$message('请选择筛选日期')
        return
      }

      this.fullscreenLoading = true
      const response = await saleApi.querySaleList(this.condition)
      if (response.status == 200) {
        if (response.data.status == -1) {
          this.$router.push({ path: '/login' })
          return
        }

        this.tableData = response.data.data

        this.channelSaleDataVos = response.data.channelSaleDataVos
        this.supplierSaleDataVos = response.data.supplierSaleDataVos
        this.carrierSaleDataVos = response.data.carrierSaleDataVos
        this.airlineSaleDataVos = response.data.airlineSaleDataVos
      }

      this.fullscreenLoading = false
    },

    // 计算所有值总计
    getSummariesCol(columns, sums, data) {
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }

        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = '——'
        }

        if (sums[index] !== '总计' && sums[index] !== '——') {
          sums[index] = parseFloat(sums[index]).toFixed(2)
          if (parseInt(sums[index]) * 100 === sums[index] * 100) {
            sums[index] = parseInt(sums[index])
          }
        }
      })
    },

    // 渠道/供应商 计算总计
    getSummaries(param) {
      const { columns, data } = param
      const sums = []

      // 计算所有值总计
      this.getSummariesCol(columns, sums, data)

      // 计算销售额（不含辅营销售额）
      let auxiliarySalesAmount = 0
      // 计算采购价格（出票费）
      let issueTicketAmount = 0

      data.forEach((oneRowData) => {
        auxiliarySalesAmount = auxiliarySalesAmount + parseFloat(oneRowData.auxiliarySalesAmount)
        issueTicketAmount = issueTicketAmount + parseFloat(oneRowData.issueTicketAmount)
      })
      console.log('行李总销售额：' + auxiliarySalesAmount)

      // 平均票价：销售额/人数
      sums[9] = parseFloat(sums[8] / sums[2]).toFixed(2)
      // 计算销售额（销售额+行李销售额）
      sums[8] = parseFloat(parseFloat(sums[8]) + auxiliarySalesAmount).toFixed(2)
      // 计算售前利润率
      sums[12] = parseFloat((sums[11] / issueTicketAmount) * 100).toFixed(2) + '%'

      // 毛利率：(含航段费)总利润/销售额
      sums[20] = parseFloat((sums[19] / sums[8]) * 100).toFixed(2) + '%'
      // 利润占比：(含航段费)售前利润/(含航段费)总利润
      sums[21] = parseFloat((sums[11] / sums[19]) * 100).toFixed(2) + '%'
      sums[22] = parseFloat((sums[15] / sums[19]) * 100).toFixed(2) + '%'
      sums[23] = parseFloat((sums[16] / sums[19]) * 100).toFixed(2) + '%'

      return sums
    },

    // 航司/航段 计算总计
    getSummaries2(param) {
      const { columns, data } = param
      const sums = []

      // 计算所有值总计
      this.getSummariesCol(columns, sums, data)

      // 计算采购价格（出票费）
      let issueTicketAmount = 0

      data.forEach((oneRowData) => {
        issueTicketAmount = issueTicketAmount + parseFloat(oneRowData.issueTicketAmount)
      })

      // 平均票价：销售额/人数
      sums[8] = parseFloat(sums[7] / sums[1]).toFixed(2)

      // 计算售前利润率
      sums[11] = parseFloat((sums[10] / issueTicketAmount) * 100).toFixed(2) + '%'

      // 毛利率：(含航段费)总利润/销售额
      sums[19] = parseFloat((sums[18] / sums[7]) * 100).toFixed(2) + '%'
      // 利润占比：(含航段费)售前利润/(含航段费)总利润
      sums[20] = parseFloat((sums[10] / sums[18]) * 100).toFixed(2) + '%'
      sums[21] = parseFloat((sums[14] / sums[18]) * 100).toFixed(2) + '%'
      sums[22] = parseFloat((sums[15] / sums[18]) * 100).toFixed(2) + '%'
      return sums
    },

    // 下载数据
    async DownLoad(type) {
      if (this.condition.bookingTime == null || this.condition.bookingTime.length === 0) {
        this.$message('请选择筛选日期')
        return
      }

      const response = await saleApi.downloadSaleList(this.condition, type)
      if (response.status == 200) {
        if (response.data.status == -1) {
          this.$router.push({ path: '/login' })
          return
        }
      }
    },

    // 城市查询
    async querySearchCity(queryString, cb) {
      const response = await commonApi.getCities(queryString)
      tokenVerify(this, response)
      const results = response.data.data.cities
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 1 * Math.random())
    },
    // 出发城市
    handleSelectFromCity(item) {
      this.condition.fromCity = item.cityCode
    },
    // 到达城市
    handleSelectToCity(item) {
      this.condition.toCity = item.cityCode
    },
    changeChannelType() {
      this.queryCidFlag = this.condition.channelType == 0
      this.condition.cids = []
    },
    changeSupplierType() {
      this.queryPccFlag = this.condition.supplierType == 2
      this.condition.pccs = []
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  width: 99%;
  min-width: 720px;
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(11, 37, 64, 0.1);
  border-radius: 4px;
  margin: 10px 10px 12px 10px;
}

.card_2 {
  width: 99%;
  min-width: 720px;
  margin: 0 10px 12px 10px;
  background: #ffffff;
  box-shadow: 0 0 6px 0 rgba(11, 37, 64, 0.1);
  border-radius: 4px;
}

/deep/.el-table .invalid-row {
  background: rgb(247, 234, 234);
}

.app-container {
  min-width: 1080px;
}

.el-date-editor--datetimerange.el-input__inner {
  width: auto;
}
.table_ {
  margin: 20px 0;
}

// 标题样式
.el_col_span {
  display: block;
  font-weight: bolder;
  text-align: right;
  align-items: center;
  //margin-bottom: 4px;
}

// card标题
.title {
  width: 95%;
  height: 20px;
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: bolder;
  color: #2b2c2f;
  line-height: 20px;
}

// 单选按钮长度
/deep/ .el-radio {
  width: 120px;
}

::v-deep {
  .el-table__footer-wrapper tbody td.el-table__cell {
    color: red;
  }
}
</style>
